const UnauthorizedAccess = () => {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="alert alert-danger text-center">
            <h1>
              <i className="fas fa-lock fa-2x mb-3"></i>
            </h1>
            <h4>Access Denied</h4>
            <p>You don't have permission to access this resource.</p>
            <button
              className="btn btn-primary"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedAccess;
